import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import PageHeader from '@/components/layout/page-header'
import EditDriverForm from '@/features/drivers/components/edit-driver-form'
import { useDocumentTitle } from '@/hooks/use-document-title'
import { localizedPageTitle } from '@/lib/page-title'

export const Route = createFileRoute('/dashboard/drivers/$driverId/edit')({
  head: () => ({ meta: [{ title: localizedPageTitle('editDriver') }] }),
  component: RouteComponent,
})

function RouteComponent() {
  useDocumentTitle('editDriver')
  const { t } = useTranslation('drivers')
  const { driverId } = Route.useParams()

  return (
    <div className="mx-auto max-w-6xl space-y-4 pb-4">
      <PageHeader title={t('editDriver')} subtitle={t('updateDriverInfo')} />

      <EditDriverForm driverId={Number.parseInt(driverId)} />
    </div>
  )
}
